<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('groups_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('groups_table', 'batches_groups')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('groups_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    :placeholder="$t('control.search')"
                    v-model="filters.search_query"
                    v-if="hasPrivilege('vouchers_view_search_vouchers')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="groups_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu"></ul>
                      </div>
                    </th>
                    <th>
                      <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      /> -->
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.code") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.batch_name") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.user") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.used_by") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.status") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.amount") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.valid_before") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.redeemed") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.canceled") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.notes") }}
                    </th>
                    <th class="sorting">
                      {{ $t("vouchers.created_at") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('vouchers_view_search_vouchers')">
                    <th></th>
                    <th></th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <input
                        @change="applyFilters"
                        v-model="filters.code"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <input
                        @change="applyFilters"
                        v-model="filters.batch_name"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <!-- <input
                        @change="applyFilters"
                        v-model="filters.user_email"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      /> -->
                    </th>
                    <th></th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <select
                        class="form-select form-select-sm"
                        v-model="filters.status"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option
                          v-for="(item, index) in statuses"
                          :key="index"
                          :value="item.id"
                          >{{ $t(`vouchers.statuses.${item.value}`) }}</option
                        >
                      </select>
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;"></th>
                    <th rowspan="1" colspan="1" style="border-left: none;"></th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <select
                        class="form-select form-select-sm"
                        v-model="filters.redeemed"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="yes">{{ $t("control.yes") }}</option>
                        <option value="no">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <select
                        class="form-select form-select-sm"
                        v-model="filters.canceled"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="yes">{{ $t("control.yes") }}</option>
                        <option value="no">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <input
                        @change="applyFilters"
                        v-model="filters.notes"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <input
                        @change="applyFilters"
                        v-model="filters.canceled_at"
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="yyyy-MM-dd"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(voucher, index) in dataList" :key="voucher.id">
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('vouchers_cancel_vouchers')">
                            <button
                              @click="showCancelDialog(voucher)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("vouchers.cancel") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="voucher.selected"
                        @click="selectData(voucher)"
                      />
                    </td>
                    <td>
                      <div class=" break-normal" style="width: 12rem;">
                        <span
                          v-if="voucher.is_valid && !voucher.redeemed"
                          class="badge bg-label-success"
                        >
                          {{ voucher.code }}
                        </span>
                        <span v-else class="badge bg-label-danger">
                          {{ voucher.code }}
                        </span>
                      </div>
                    </td>
                    <td>
                      {{ voucher.voucher_batch.name }}
                    </td>
                    <td>
                      {{ voucher.user_email }}
                    </td>
                    <td>
                      <div v-if="voucher.account">
                        <div
                          v-if="hasPrivilege('accounts_view_index_accounts')"
                        >
                          <a
                            class="btn btn-link"
                            :href="`accounts/${voucher.account.id}`"
                            @click.prevent="
                              $router.push(`/accounts/${voucher.account.id}`)
                            "
                            dir="ltr"
                            >{{ voucher.account.username }}</a
                          >
                        </div>
                        <div v-else>
                          {{ voucher.account.username }}
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ $t(`vouchers.statuses.${voucher.status}`) }}
                    </td>
                    <td>
                      {{
                        voucher.amount + " " + voucher.voucher_batch.currency
                      }}
                    </td>
                    <td>
                      {{
                        voucher.valid_before
                          ? voucher.valid_before
                          : $t("control.none")
                      }}
                    </td>
                    <td>
                      {{ voucher.redeemed ? voucher.redeemed_at : "" }}
                    </td>
                    <td>
                      {{ voucher.canceled ? voucher.canceled_at : "" }}
                    </td>
                    <td>
                      {{ voucher.notes }}
                    </td>
                    <td>
                      {{ formatDate(voucher.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import VouchersGenerate from "../components/modals/vouchers-generate.vue";
export default {
  components: { VouchersGenerate },
  computed: {
    ...mapGetters(["user"]),
  },
  name: "VouchersBatches",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showContext: false,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        code: "",
        batch_name: "",
        user_email: "",
        status: "",
        redeemed_at: "",
        canceled_at: "",
        created_at: "",
        canceled: "",
        redeemed: "",
        notes: "",
        voucher_batch_id: null,
      },
      statuses: [
        { id: 0, value: "created" },
        { id: 1, value: "issued" },
        { id: 2, value: "pending" },
        { id: 3, value: "redeemed" },
        { id: 4, value: "expired" },
        { id: 5, value: "canceled" },
      ],
      checkedBox: true,
      allSelected: false,
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      showAddBatch: false,
    };
  },
  async created() {
    if (this.$route.query.name) {
      this.filters.name = this.$route.query.name;
    }
    this.prepareFilters();
    if (this.$route.params.id) {
      this.filters.voucher_batch_id = this.$route.params.id;
    }
    this.applyFilters();
    // this.prepareColumns();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    prepareFilters() {
      var filters = localStorage.getItem("vouchers_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("vouchers_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: {
            name: this.$t("vouchers_batches.name"),
            enabled: cols[0].enabled,
          },
          currency: {
            name: this.$t("vouchers_batches.currency"),
            enabled: cols[1].enabled,
          },
          valid_before: {
            name: this.$t("vouchers_batches.valid_before"),
            enabled: cols[2].enabled,
          },
          user_email: {
            name: this.$t("vouchers_batches.user_email"),
            enabled: cols[3].enabled,
          },
          voucher_value: {
            name: this.$t("vouchers_batches.voucher_value"),
            enabled: cols[4].enabled,
          },
          vouchers_count: {
            name: this.$t("vouchers_batches.vouchers_count"),
            enabled: cols[5].enabled,
          },
          redeemed_vouchers_count: {
            name: this.$t("vouchers_batches.redeemed_vouchers_count"),
            enabled: cols[6].enabled,
          },
          created_at: {
            name: this.$t("vouchers_batches.created_at"),
            enabled: cols[7].enabled,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "vouchers?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.voucher_batch_id != null)
        requestString += `&voucher_batch_id=${this.filters.voucher_batch_id}`;
      if (this.filters.code != "")
        requestString += `&code=${this.filters.code}`;
      if (this.filters.batch_name != "")
        requestString += `&batch_name=${this.filters.batch_name}`;
      if (this.filters.user_email != "")
        requestString += `&user_email=${this.filters.user_email}`;
      if (this.filters.status != "")
        requestString += `&status=${this.filters.status}`;
      if (this.filters.redeemed != "")
        requestString += `&redeemed=${this.filters.redeemed}`;
      if (this.filters.canceled != "")
        requestString += `&canceled=${this.filters.canceled}`;
      if (this.filters.notes != "")
        requestString += `&notes=${this.filters.notes}`;
      if (this.filters.created_at != null && this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.search_query != null && this.filters.search_query != "")
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("vouchers_filters", JSON.stringify(this.filters));
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
    },
    async showCancelDialog(batch) {
      this.$swal({
        title: this.$t("vouchers.cancel_voucher") + " " + batch.code,
        text: this.$t("vouchers.this_will_cancel_selected_voucher"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("vouchers.yes_cancel"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`vouchers/${batch.id}/cancel`);
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("vouchers.voucher_has_been_canceled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD HH:mm");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns(updated) {
      localStorage.setItem(
        "vouchers_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    printCards() {
      this.$router.push(`/vouchers/${this.selectedData.id}/print`);
      this.$store.commit("changeKey");
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    exportCsv(id) {
      window.location.href =
        localStorage.getItem("server_api") + `export/${id}`;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("vouchers_filters", JSON.stringify(this.filters));
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
